import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Plus, Save, X, Wrench } from "lucide-react";

export default function AdminServicos() {
  const [items, setItems] = useState(null);
  const [novo, setNovo] = useState("");
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/services").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  const add = (e) => {
    e.preventDefault();
    const v = novo.trim();
    if (!v) return;
    if (items.includes(v)) { toast.error("Serviço já existe."); return; }
    setItems([...items, v]);
    setNovo("");
    setDirty(true);
  };

  const remove = (s) => { setItems(items.filter((x) => x !== s)); setDirty(true); };

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/services", { items });
      setItems(data);
      setDirty(false);
      toast.success("Lista de serviços atualizada — já vale para o formulário do site.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  if (!items) {
    return <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-600" /></div>;
  }

  return (
    <div data-testid="admin-services-page" className="max-w-3xl">
      <h1 className="display text-3xl font-extrabold uppercase">Serviços</h1>
      <p className="mt-1 text-sm text-slate-500">
        Lista de serviços oferecidos no formulário público de orçamento. Adicione ou remova conforme a operação evolui.
      </p>

      <form onSubmit={add} className="mt-6 flex gap-2">
        <input
          data-testid="service-new-input"
          value={novo}
          onChange={(e) => setNovo(e.target.value)}
          placeholder="Novo serviço…"
          className="flex-1 bg-slate-900/70 border border-slate-700 rounded-md px-3 py-2.5 text-sm outline-none focus:border-orange-500 transition-colors placeholder:text-slate-600"
        />
        <button data-testid="service-add-button" className="inline-flex items-center gap-1.5 pill-accent rounded-md px-4 py-2.5 text-xs font-semibold uppercase tracking-wider">
          <Plus className="w-4 h-4" /> Adicionar
        </button>
      </form>

      <ul className="mt-5 space-y-2" data-testid="services-list">
        {items.map((s) => (
          <li key={s} className="flex items-center justify-between gap-3 card-tactical rounded-md px-4 py-3" data-testid={`service-item-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <span className="flex items-center gap-2.5 text-sm text-slate-200">
              <Wrench className="w-4 h-4 text-orange-500" strokeWidth={1.5} /> {s}
            </span>
            <button onClick={() => remove(s)} data-testid={`service-remove-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="text-slate-500 hover:text-red-400 transition-colors" aria-label={`Remover ${s}`}>
              <X className="w-4 h-4" />
            </button>
          </li>
        ))}
      </ul>

      {dirty && (
        <button data-testid="services-save-button" onClick={save} disabled={saving}
          className="mt-5 inline-flex items-center gap-2 pill-accent rounded-md px-6 py-2.5 text-sm font-semibold uppercase tracking-wider disabled:opacity-60 transition">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Salvar alterações
        </button>
      )}
    </div>
  );
}
